document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".pc-item").forEach(card => {
    const variants = JSON.parse(card.dataset.variants || "[]");
    if (!variants.length) return;

    const priceEl = card.querySelector(".pc-price");
    const addBtn = card.querySelector(".pc-add-btn");
    const imageEl = card.querySelector(".pc-image img");

    // Helper: get correct variant based on selected options
    function getSelectedVariant() {
      if (variants.length === 1) return variants[0];
      const selectedOptions = [];
      card.querySelectorAll(".pc-option-select").forEach(sel => {
        selectedOptions[parseInt(sel.dataset.optionPosition, 10)] = sel.value;
      });
      return variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      ) || variants[0];
    }

    // Update price/image on change
    function updateCard() {
      const variant = getSelectedVariant();
      if (!variant) return;

      if (priceEl) {
        priceEl.textContent = new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR"
        }).format(variant.price / 100);
      }

      if (variant.featured_image && imageEl) {
        const imageUrl = variant.featured_image.startsWith("http")
          ? variant.featured_image
          : "https:" + variant.featured_image;        
        imageEl.src = imageUrl;
      }

      // Update data-variant on the parent swipable-card
      const wrapper = card.closest(".swipable-card");
      if (wrapper) {
        wrapper.dataset.variant = variant.id;
      }

    }

    card.querySelectorAll(".pc-option-select").forEach(sel => {
      sel.addEventListener("change", updateCard);
    });

    if (addBtn) {
      addBtn.addEventListener("click", () => {
        const variant = getSelectedVariant();
        if (!variant || !variant.available) {
          alert("This option is not available.");
          return;
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: 1 }]
          })
        })
          .then(res => {
            if (!res.ok) throw new Error("Add to cart failed");
            return res.json();
          })
          .then(() => {
            window.location.reload();
          })
          .catch(err => {
            console.error(err);
            alert("Something went wrong, Try Again.");
            window.location.reload();
          });
      });
    }

    // Init default if you want to run on first load
    // updateCard();
  });
});